module.exports = __webpack_public_path__ + "img/AlertCA_Logo_White.f2f5c420.svg";